import { render, staticRenderFns } from "./GameDice.vue?vue&type=template&id=41890346&"
import script from "./GameDice.vue?vue&type=script&lang=js&"
export * from "./GameDice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports